import { TrackingName } from "./tracking.constant";

export interface TrackingInfo {
    name: TrackingName | string;
    category?: string;
    label?: string;
    entity?: string;
    selectionLength?: number;
    screen?: string;
    shows?: string;
    trackTimeSpent?: boolean;
    startTime?: number;
    unique_id?: string;
    displayMode?: DISPLAY_MODE;
}

export interface User {
    userId: number;
    login: string;
    isRoot?: boolean;
    displayMode?: DISPLAY_MODE;
    authId?: string;
    /** Login of the impersonated user when an admin is "logged as" someone else. */
    logAs?: string | null;
}

export enum DISPLAY_MODE {
    BROWSER = 'browser',
    STANDALONE = 'standalone',
    MINIMAL_UI = 'minimal-ui',
    FULLSCREEN = 'fullscreen',
    TWA = 'twa',
    WINDOW_CONTROLS_OVERLAY = 'window-controls-overlay',
    UNKNOWN = 'unknown',   
}

export interface TrackingService {

    initAction({}: Pick<TrackingInfo, "name">): void;

    trackAction(trackingInfo: TrackingInfo): void;

    /**
     *  method not throwable
     */
    setUser(user: User | null): void;

    trackTask(trackingInfo: TrackingInfo, state: 'begin' | 'end' | 'error', error: Error): void;

    getPWADisplayMode(): DISPLAY_MODE;
}

export {
    TrackingName,
}